var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14H17.3333L12 19.3333L6.66667 14H10.6667V8.66663H13.3333V14ZM16 3.33329H2.66667V24.6666H21.3333V8.66663H16V3.33329ZM0 1.98929C0 1.25863 0.596 0.666626 1.332 0.666626H17.3333L24 7.33329V25.9906C24.0012 26.1657 23.968 26.3393 23.9021 26.5016C23.8362 26.6638 23.739 26.8115 23.6161 26.9362C23.4931 27.0609 23.3468 27.1601 23.1855 27.2282C23.0242 27.2964 22.8511 27.3321 22.676 27.3333H1.324C0.973837 27.3309 0.63869 27.1908 0.390957 26.9433C0.143224 26.6958 0.00279287 26.3608 0 26.0106V1.98929Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.fcea844f0289543b1d0f3ae52e9d65ef.svg";
export { ForwardRef as ReactComponent };